import { Controller } from "@hotwired/stimulus"

// Controller for looking up NPI provider information
// Debounces input changes and fetches provider card via turbo stream
export default class extends Controller {
  static targets = ["input", "card"]
  static values = {
    url: String,
    domId: String,
    debounceMs: { type: Number, default: 500 }
  }

  connect() {
    this.timeout = null
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  lookup() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    const npi = (this.inputTarget.value || "").trim()

    // Clear card if NPI is empty
    if (npi.length === 0) {
      if (this.hasCardTarget) {
        this.cardTarget.innerHTML = ""
      }
      return
    }

    // Only lookup if it looks like a valid NPI (10 digits)
    if (npi.length !== 10 || !/^\d{10}$/.test(npi)) {
      // Don't clear or show error, just wait for more input
      return
    }

    // Debounce the actual fetch
    this.timeout = setTimeout(() => {
      this.fetchCard(npi)
    }, this.debounceValue)
  }

  fetchCard(npi) {
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("npi", npi)
    url.searchParams.set("dom_id", this.domIdValue)

    fetch(url, {
      method: "GET",
      headers: {
        "Accept": "text/vnd.turbo-stream.html"
      }
    })
      .then(response => response.text())
      .then(html => Turbo.renderStreamMessage(html))
  }
}

